module.exports = "/images/AssembleAPackage_1of2.jpg";